import styled from "styled-components";

export const Container = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: center;

    @media (max-width: 900px) {
        flex-direction: column;
        align-items: start;
    }
`;

export const Title = styled.div``;

export const H4 = styled.p`
    font-size: 24px;
`;

export const H6 = styled.p`
    font-size: 16px;
    color: ${(props) => props.theme.colors.gray.gray_500};
`;

export const ContentFilter = styled.div`
    display: flex;
    gap: 16px;
`;

export const Button = styled.button`
    display: flex;
    align-items: center;
    padding: 8px;
    
    border-radius: 4px;
    gap: 8px;
    background-color: ${(props) => props.theme.colors.gray.gray_50};
    
    &:hover{
        background-color: ${(props) => props.theme.colors.gray.gray_100};
    }
`;

export const LabelDate = styled.label``;

export const FilterSelect = styled.select`
    background-color: ${(props) => props.theme.colors.gray.gray_50};
    border-radius: 30px;
    padding: 5px 10px;

  &:hover {
    background-color: ${(props) => props.theme.colors.gray.gray_100};
  }
`;

export const ButtonClose = styled.button`
  display: flex;
  justify-content: center;
  background-color: transparent;
  padding: 4px 0px;

  svg:hover{
    background-color: ${(props) => props.theme.colors.gray.gray_100};
  }
`;

export const ContentInputSearch = styled.div`
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 4px;
    width: 100%;

    border: 1px solid ${(props) => props.theme.colors.gray.gray_600};
    border-radius: 24px;
    padding: 0px 5px;
`;

export const Input = styled.input`
    width: 65%;
    border-radius: 4px;
    padding: 8px 16px;
    background-color: transparent;
`;

export const ContentButton = styled.div`
    display: flex;
    justify-content: end;
    width: 25%;

    div{
        width: 40%;
        display: flex;
        align-items: center;
        justify-content: center;
    }
`;